import { useEffect } from 'react'
import { track } from '../utils/track'

// Module-level so a remount (or StrictMode's double effect) can't refire it.
let hasFired = false

/** Fires a single ViewContent event once the reader passes 50% of the page. */
export function useViewContent(): void {
  useEffect(() => {
    if (hasFired) return

    const onScroll = () => {
      if (hasFired) return
      const scrolled = window.scrollY + window.innerHeight
      const total = document.body.scrollHeight
      if (total > 0 && scrolled / total >= 0.5) {
        hasFired = true
        track('ViewContent')
        window.removeEventListener('scroll', onScroll)
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
}
